module.exports = __webpack_public_path__ + "img/actionsfill.b93f43b5.svg";